import { Check, Copy } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'

import { cn } from '@/shared/lib/cn'
import { useT } from '@/shared/i18n'

export interface CopyButtonProps {
  value: string
  label?: string
  className?: string
}

export function CopyButton({ value, label, className }: CopyButtonProps) {
  const t = useT()
  const [copied, setCopied] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current)
    },
    [],
  )

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      if (timer.current) clearTimeout(timer.current)
      timer.current = setTimeout(() => setCopied(false), 1500)
    } catch {
      /* portapapeles bloqueado: no hay nada util que mostrar */
    }
  }

  return (
    <button
      type="button"
      onClick={copy}
      aria-label={copied ? t('common.action.copied') : (label ?? t('common.action.copy'))}
      title={copied ? t('common.action.copied') : (label ?? t('common.action.copy'))}
      className={cn(
        'inline-flex h-6 w-6 items-center justify-center rounded-[var(--radius-control)]',
        'text-text-3 transition-colors duration-[var(--motion-fast)]',
        'hover:bg-surface-2 hover:text-text-1',
        copied && 'text-signal',
        className,
      )}
    >
      {copied ? <Check size={13} aria-hidden="true" /> : <Copy size={13} aria-hidden="true" />}
    </button>
  )
}
